module.exports = __webpack_public_path__ + "img/company.874a40fe.jpg";